import { Button } from 'antd';
import React from 'react';

type Event = {
  preventDefault: () => void;
  stopPropagation: () => void;
};

export function MultipleSelectSearchActionsOption({
  addAll,
  removeAll,
}: {
  addAll: () => void;
  removeAll: () => void;
}) {
  function removeAllOnly(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    removeAll();
  }

  function addAllOnly(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    addAll();
  }

  return (
    <>
      <div className="multiple-select-search-full-actions">
        <Button
          type="link"
          onClick={addAllOnly}
          className="multiple-select-search-full-actions__button"
        >
          Select All
        </Button>
        <Button
          type="link"
          onClick={removeAllOnly}
          className="multiple-select-search-full-actions__button"
        >
          Reset
        </Button>
      </div>
      <style jsx>{`
        .multiple-select-search-full-actions {
          display: flex;
          justify-content: space-between;
          cursor: default;
        }

        .multiple-select-search-full-actions
          :global(.multiple-select-search-full-actions__button) {
          padding: 0;
          height: 24px;
        }
      `}</style>
    </>
  );
}
